import React from 'react';
import { useNavigate } from 'react-router-dom';

import { BookingContext, resetSavedLocalData } from '@app/components/Pages/Booking/Booking';
import { PhoneProviderContext } from '@app/components/UI/PhoneProvider/PhoneProvider';

interface LargePetProps {
	title: string;
	onClick?: () => void;
}

const LargePet: React.FC<LargePetProps> = ({ title, onClick }) => {
	const navigate: any = useNavigate();
	const context = React.useContext(BookingContext);
	const contextPhone = React.useContext(PhoneProviderContext);

	if (!context?.state) throw new Error('Error context');
	if (!contextPhone?.state) throw new Error('Error PhoneProvider context');

	const {
		state: { item },
	} = context;

	const defaultDone = () => {
		resetSavedLocalData(navigate, '/');
	};

	return (
		<div className="online-booking-step-container no-one-can-help">
			<h1>{title}</h1>

			<div className="no-one-can-help__text">
				<p>{`Due to ${item?.petName.trim() || 'Pet'}’s size we need a little extra information to complete your booking.`}</p>
				<p>
					We will call you from
					{' '}
					<a href={contextPhone.state.phoneNumberHref} className="inline-block inline-link">
						{contextPhone.state.phoneNumberDisplay}
					</a>
					{' '}
					to help finalize your booking. If you don’t hear from us immediately, please feel free to
					call us at this number above.
				</p>
				<p>Thank you for your patience!</p>
			</div>

			<button onClick={onClick || defaultDone} className="btn btn-primary link">
				Done
			</button>
		</div>
	);
};

export default LargePet;
